//GeneratorFlag:[NoChange]
<template>
	<div>kaveh.app.toolbar.asset.notification</div>
</template>